import { Image, View } from "@aws-amplify/ui-react";
import { useMediaQuery } from "@mui/material";
import { images } from "constants/index";
import { motion } from "framer-motion";

export default function TheProblems() {
  const wmatches = useMediaQuery("(min-width:1100px)");
  return (
    <View className={`relative flex ${wmatches ? "" : "flex-col"}  w-full`}>
      {/* The problems side */}
      <View
        className={`relative flex ${
          wmatches ? "w-[50%]" : " w-[100%]"
        } flex-wrap pr-10`}
      >
        <motion.div
          initial={{
            opacity: 0.3,
            scale: 0.8,
          }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          transition={{ duration: 2 }}
          className="font-extrabold text-[66px] pl-5"
        >
          <div className=" font-lolita-one">THE PROBLEMS</div>
        </motion.div>

        <div className="relative flex flex-col pl-8 pr-5 font-lolita-one">
          <div className="font-extrabold text-[40px] underline">
            FOOD DESERTS
          </div>
          <div className=" text-white font-medium text-[22px]">
            IN EAST FLATBUSH THE RATIO IS 21 BODEGAS TO GROCERY/SUPERMARKET.
          </div>

          <div className="font-extrabold text-[40px] pt-5 underline">
            PUBLIC SAFETY
          </div>
          <div className=" font-medium text-[22px] text-white">
            SINCE 2021, CRIME RATE HAS RISED TO THE HIGHEST RATE OF VIOLENCE,
            WITH A INFLUX OF GUNS OR ROBBERIES.
          </div>

          <div className="font-extrabold text-[40px] pt-5 underline">
            LACK OF MENTAL HEALTH RESOURCES
          </div>
          <div className="font-medium text-[22px] text-white">
            NO MENTAL HEALTH SERVICES AVAILABLE TO THOSE IN THE AREA
          </div>

          <div className="font-extrabold text-[40px] pt-5 underline">
            LACK OF NEIGHBORHOOD DEVELOPMENT
          </div>
          <div className="font-medium text-[22px] text-white ">
            POLLUTION, TRASH, AND INFESTATION ARE JUST A MERE GLIMPSE AT THE
            INFRASTRUCTURE PROBLEMS SEEN IN THE 90Z.
          </div>

          <div className="font-extrabold text-[40px] pt-5 underline">
            LACK OF COMMUNITY ENGAGEMENT
          </div>
          <div className="font-medium text-[22px] text-white">
            NO REAL ACCESS TO COMMUNITY SPACES , AND THERE LACKS ANY SPORTS
            CLUBS, OR LOCAL EVENTS FOR ENJOYMENT.
          </div>
        </div>
      </View>
      {/* The problems side */}
      {/* Quote */}
      <View
        className={`relative flex flex-row ${
          wmatches ? "w-[50%]" : " w-[100%]"
        } py-10 mt-5 bg-[rgba(203,213,225,.3)]`}
      >
        <Image
          alt=""
          objectFit="cover"
          width={200}
          height={200}
          src={images.flower2}
        />
        <View className="relative self-center flex flex-col pr-10">
          <motion.div
            initial={{
              opacity: 0.3,
              scale: 0.2,
            }}
            whileInView={{
              opacity: 1,
              scale: 1,
            }}
            transition={{
              duration: 3,
              type: "spring",
            }}
          >
            <div className=" font-lolita-one">
              <div className="relative flex text-[26px] font-bold">
                when morality comes up against profit, it is seldom that profit
                loses
              </div>
              <div className="pt-3 relative flex text-[20px] font-medium">
                SHIRLEY CHISHOLM -
              </div>
            </div>
          </motion.div>
        </View>
        <Image
          alt=""
          display={wmatches ? "" : "none"}
          // backgroundColor="red"
          objectFit="cover"
          alignSelf="flex-end"
          width={200}
          height={200}
          src={images.flower}
        />
      </View>
    </View>
  );
}
